/// <amd-module name="Repos/Views/PullRequest/Components/ActivityFeed/ActivityCards/VoteUpdatedCard" />
import * as React from "react";
import * as Resources from "Repos/Views/PullRequest/Resources";
import { getVoteStatusProps } from "Repos/Views/PullRequest/Util/Vote";
import { FormatComponent } from "VSS/Platform/Components/Format";
import { Components } from "VSS/Platform/Layout";
import { Status, StatusSize } from "VSSUI/Status";
import { getIdentity, getIdentityComponent, getPropertyValue } from "../Utils/ActivityFeedUtils";
import { ActivityCardSubtle, IActivityCardSharedProps } from "./ActivityCardSubtle";
import { ActivityShimmer } from "./ActivityShimmer";

enum VoteStatuses {
    Approve = 10,
    ApproveWithComment = 5,
    None = 0,
    Waiting = -5,
    Reject = -10
}

export const VoteUpdatedCard: React.FunctionComponent<IActivityCardSharedProps> = props => {
    const { isShim } = props;
    const voteStatus = parseInt(getPropertyValue(props.thread, "CodeReviewVoteResult", "0"));
    let personaInfo;

    if (!isShim) {
        const identityId = getPropertyValue(props.thread, "CodeReviewVotedByIdentity");
        const identity = getIdentity(props.thread, identityId);

        if (!identity) {
            return null;
        }
        const persona = getIdentityComponent(identity, "margin-right-8");

        let format = "";

        switch (voteStatus) {
            case VoteStatuses.Approve:
                format = Resources.ActivityFeedApproved;
                break;
            case VoteStatuses.ApproveWithComment:
                format = Resources.ActivityFeedApprovedWithSuggestions;
                break;
            case VoteStatuses.None:
                format = Resources.ActivityFeedReset;
                break;
            case VoteStatuses.Waiting:
                format = Resources.ActivityFeedWaiting;
                break;
            case VoteStatuses.Reject:
                format = Resources.ActivityFeedRejected;
                break;
        }

        personaInfo = (
            <FormatComponent elementType={null} format={format}>
                {persona}
            </FormatComponent>
        );
    }

    return (
        <ActivityCardSubtle createDate={props.thread.publishedDate}>
            <Status {...getVoteStatusProps(voteStatus)} className="activity-card-first-image" size={StatusSize.l} />
            {!isShim ? personaInfo : <ActivityShimmer />}
        </ActivityCardSubtle>
    );
};

Components.add("ms.vss-code-web.vote-updated-activity-card", VoteUpdatedCard);
